export default __webpack_public_path__ + "static/media/ListInactive.67fd9841.svg";